import { money, shortDate } from "./format";

// Sold-comparables grid. Presentational — renders nothing when there are no comps.
export default function CompsGrid({ comps, heading = "Recent comparable sales" }) {
  if (!comps || comps.length === 0) return null;

  return (
    <section className="ssc-report-section">
      <h3>{heading}</h3>
      <div className="ssc-report-comps">
        {comps.map((c, i) => (
          <div key={`${c.address}-${i}`} className="ssc-report-comp">
            <div className="ssc-report-comp-addr">{c.address}</div>
            <div className="ssc-report-comp-price">{money(c.sold_price)}</div>
            <div className="ssc-report-comp-meta">
              {[
                c.beds ? `${c.beds} bd` : null,
                c.baths ? `${c.baths} ba` : null,
                c.sqft ? `${c.sqft.toLocaleString()} sqft` : null,
              ]
                .filter(Boolean)
                .join(" · ")}
            </div>
            <div className="ssc-report-comp-meta">
              {[c.sold_date ? `Sold ${shortDate(c.sold_date)}` : null, c.distance ? `${c.distance} mi away` : null]
                .filter(Boolean)
                .join(" · ")}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
